import useData from "./useData";

const useOrder = () => {
  const { getFromServer, updateRecord } = useData();

  const saveOrder = async (order) => {
    const updateResults = await updateRecord("Order", order, true);
  };

  const calculateTotals = (items) => {
    return items.reduce(
      (acc, item) => {
        const qty = parseInt(item.quantity, 10) || 0;
        const price = parseFloat(item.price) || 0;

        acc.totalItems++;
        acc.totalQty += qty;
        acc.totalAmount += qty * price;

        return acc;
      },
      { totalItems: 0, totalQty: 0, totalAmount: 0 }
    );
  };

  const getOrderByCallResult = async (callResultId) => {
    const order = await getFromServer({
      entityName: "Order",
      filter: { callResultId },
    });

    return order;
  };

  return {
    saveOrder,
    calculateTotals,
    getOrderByCallResult,
  };
};

export default useOrder;
